export default __webpack_public_path__ + "static/media/sl-entrance.54d6eea0.svg";